"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("./index");
var image_1 = __importDefault(require("next/image"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Collapse = function (_a) {
    var keyProp = _a.keyProp, isExpanded = _a.isExpanded;
    return (react_1.default.createElement(index_1.Cell, { key: keyProp },
        react_1.default.createElement(image_1.default, { className: "".concat(styles_module_scss_1.default.collapse, " ").concat(isExpanded ? styles_module_scss_1.default.isExpanded : ''), width: 16, height: 16, src: "/img/icons/arrowCollapseDown.svg", alt: "arrow" })));
};
exports.default = Collapse;
